import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, Row, Col, Popconfirm } from 'antd';
import GridView from '../../../components/elements/GridView/index';
import CreateManagementAlertForm from '../forms/createManagementAlertForm';
import * as driverActions from '../../../core/driver/driverActions';
import { getPaginationTotal } from '../../../components/elements/GridView/GridViewBase/Pagination';
import { Link } from 'react-router-dom';

const { DB_DATE_FORMAT } = require('../../../core/constants').default;

class DriverManagementAlertsTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showCreateAlertForm: false,
            serviceAlert: {
                id: null,
                name: null,
                description: null,
                service_date: null,
                frequency: null,
                frequency_desc: null,
                asset_id: null,
                user_id: null,
                alert_type: 1,
            },
        };
    }

    componentDidMount() {
        const {
            actions, setLoadedState, serviceAlertsTabLoaded, driverId, driverViewManagementAlertFilters,
        } = this.props;

        if (!serviceAlertsTabLoaded) {
            let params = {
                driverId,
                alert_type: 1,
                page: 1,
            };
            if (driverViewManagementAlertFilters?.length) {
                const matches = driverViewManagementAlertFilters.filter(f => parseInt(f.driverId) === parseInt(driverId));
                if (matches?.length) {
                    params = matches[0].filters;
                }
            }
            actions.getDriverServiceAlertsRequest(params);
            setLoadedState();
        }
    }

    onPageChange = (page, pageSize) => {
        const { onPageChange } = this.props;

        onPageChange(page, pageSize);
    };

    onTableChange = (pagination, filters, sorter, extra) => {
        const { onTableChange, serviceAlertsPagination } = this.props;

        if (pagination && pagination.current === serviceAlertsPagination.currentPage) {
            onTableChange(pagination, filters, sorter, extra);
        }
    };

    createServiceAlert = (values) => {
        const { actions, driverId } = this.props;
        const { serviceAlert } = this.state;

        if (values.service_date) {
            values.service_date = values.service_date.format(DB_DATE_FORMAT);
        }
        actions.createDriverServiceAlertRequest({
            driverId,
            alertId: serviceAlert.id || 0,
            ...values,
        });
        this.setState({ showCreateAlertForm: false });
    };

    deleteServiceAlert = (id) => {
        const { actions, driverId } = this.props;

        actions.deleteDriverServiceAlertRequest({
            alertId: id,
            driverId,
        });
        this.setState({ showCreateAlertForm: false });
    };

    clearForm = () => {
        this.setState({
            showCreateAlertForm: false,
            serviceAlert: {
                id: null,
                name: null,
                description: null,
                service_date: null,
                frequency: null,
                frequency_desc: null,
                asset_id: null,
                user_id: null,
                alert_type: 0,
            },
        });
    };

    createForm = () => {
        this.setState({
            showCreateAlertForm: false,
            serviceAlert: {
                id: null,
                name: null,
                description: null,
                service_date: null,
                frequency: null,
                frequency_desc: null,
                asset_id: null,
                user_id: null,
                alert_type: 0,
            },
        });

        setTimeout(() => this.setState({
            showCreateAlertForm: true,
        }), 1);
    };

    render() {
        const {
            serviceAlerts, serviceAlertsPagination,
        } = this.props;
        const { showCreateAlertForm, serviceAlert } = this.state;

        const listAssetServiceAlerts = serviceAlerts.map((assetAlert, assetAlertIndex) => {
            const tempAssetAlert = {};
            tempAssetAlert.alert_name = assetAlert.name;
            tempAssetAlert.alert_description = assetAlert.description;
            tempAssetAlert.frequency = assetAlert.frequency_desc;
            tempAssetAlert.actions = (
                <>
                    <Link
                        className="btn-actions"
                        onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                                showCreateAlertForm: true,
                                serviceAlert: {
                                    id: assetAlert.id,
                                    name: assetAlert.name,
                                    description: assetAlert.description,
                                    service_date: assetAlert.service_date,
                                    frequency: assetAlert.frequency,
                                    frequency_desc: assetAlert.frequency_desc,
                                    asset_id: assetAlert.asset_id,
                                    user_id: assetAlert.user_id,
                                    alert_type: assetAlert.alert_type,
                                },
                            });
                        }}
                    >
                        Edit
                    </Link>
                    <Popconfirm
                        onConfirm={() => this.deleteServiceAlert(assetAlert.id)}
                        title="Are you sure to delete this alert？"
                    >
                        <Link className="btn-actions">
                            Delete
                        </Link>
                    </Popconfirm>
                </>
            );
            return tempAssetAlert;
        });

        return (
            <>
                {!showCreateAlertForm && (
                    <Row>
                        <Col span={24}>
                            <Button
                                style={{ float: 'right' }}
                                type="primary"
                                onClick={this.createForm}
                                data-testid='driver-details-management-alerts_create-btn'
                            >
                                Create
                            </Button>
                        </Col>
                    </Row>
                )}
                {showCreateAlertForm ? (
                    <CreateManagementAlertForm
                        serviceAlert={serviceAlert}
                        clearForm={this.clearForm}
                        onSubmit={this.createServiceAlert}
                    />
                ) : (
                    <>
                        <br />
                        <GridView
                            data={listAssetServiceAlerts}
                            onChange={this.onTableChange}
                            sortableColumns={['start_time', 'end_time', 'time_driven', 'driver', 'area_driven', 'score', 'events']}
                            pagination={{
                                total: parseInt(serviceAlertsPagination.totalRecords, 10),
                                showSizeChanger: false,
                                pageSize: parseInt(serviceAlertsPagination.perPageCount, 10),
                                onChange: this.onPageChange,
                                showTotal: getPaginationTotal,
                            }}
                        />
                    </>
                )}
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        serviceAlerts: state.driver.serviceAlerts,
        serviceAlertsPagination: state.driver.serviceAlertsPagination,
        assetList: state.asset.assetList,
        driverViewManagementAlertFilters: state.driver.driverViewManagementAlertFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...driverActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DriverManagementAlertsTab);
